









































































import { Vue, Component, Ref } from "vue-property-decorator";
import MemberClientItemComponent from "./MemberClientItem.vue";

import { manageMemberClientAccess } from "@/permissions/UserPermissions";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";
import { getClientId, getMemberClientIds, getMemberClientDetailsByIds } from "@/data/repository/ClientRepository";
import MemberClientDialog from "../client/MemberClientDialog.vue";
import { MemberClientDetails } from "@/data/models/Client";
import { COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK } from "@/utils/colors";
import { themed } from "@/utils/Theme";
import { getExternalSystemsOfClient } from "@/data/repository/ExternalSystemRepository";
import { ExternalSystem } from "@/data/models/ExternalSystem";
import { getEffectiveUser } from "@/utils/ViewAs";

@Component({
  components: {
    "member-client-item": MemberClientItemComponent,
    "member-client-dialog": MemberClientDialog,
  },
})
export default class MemberClientsManagementComponent extends Vue {
  @Ref("memberClientDialog")
  memberClientDialog!: MemberClientDialog;

  isLoading = true;

  memberClientIds: string[] = [];
  memberClientDetails: MemberClientDetails[] = [];
  externalSystems: ExternalSystem[] = [];

  errorSnackbar = false;
  errorSnackbarText = "";
  successSnackbar = false;
  successSnackbarText = "";

  async onCreateNewMemberClient() {
    await this.memberClientDialog.show(undefined, this.externalSystems);
  }

  /** Table header background: light grey in light mode, dark elevated surface in dark mode. */
  get tableHeaderColor() {
    return themed(COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK);
  }

  /** The user whose view this shows: the chosen one while "Sicht auf" is active (ticket 2610052). */
  get activeUser() {
    return getEffectiveUser();
  }

  get sortedMemberClients() {
    return this.memberClientDetails
      .sort((c1, c2) => (c1.shortName || c1.clientName || '').localeCompare(c2.shortName || c2.clientName || ''));
  }

  get isAllowedToCreateMemberClient() {
    return manageMemberClientAccess(this.activeUser);
  }

  onError(data: string) {
    this.showErrorSnackbar(data);
  }

  async onSuccess(data: string, memberClientId: string) {
    await this.loadMemberClients(memberClientId);
    this.showSuccessSnackbar(data);
  }

  showErrorSnackbar(message: string) {
    this.errorSnackbar = true;
    this.errorSnackbarText = message;
  }

  showSuccessSnackbar(message: string) {
    this.successSnackbar = true;
    this.successSnackbarText = message;
  }

  setToolbarTitle() {
    const baseTitle = this.$t("pages.settings").toString();
    const currentPageTitle = this.$t("settings.administrator.memberClientsManagement.title").toString();

    const toolbarTitle = baseTitle + " > " + currentPageTitle;

    ToolbarContentModule.setToolbarTitle(toolbarTitle);
  }

  async created() {
    this.isLoading = true;

    await this.loadMemberClients();

    this.isLoading = false;
  }

  async loadMemberClients(memberClientId?: string) {
    const memberClientIds = getMemberClientIds().filter((id => id !== getClientId()));
    
    if (memberClientId && !memberClientIds.includes(memberClientId)) {
      memberClientIds.push(memberClientId);
    }

    if (!memberClientIds || memberClientIds.length === 0) {
      return;
    }

    const [ memberClientDetails, externalSystems ] = await Promise.all([
      getMemberClientDetailsByIds(memberClientIds),
      getExternalSystemsOfClient()
    ]);

    this.memberClientDetails = memberClientDetails;
    this.externalSystems = externalSystems;
  }

  async mounted() {
    this.setToolbarTitle();
  }
}
